// TODO: adjust path after data migration
import rawData from "../../../generated/mbk/produktfinder-data.json"
import { calculateMatchPercentage } from "../../../anwendungskonfigurator/misc/utils"

const groupMerkmaleByLabel = data => {
    const groupedData = {}
    data.forEach(innerArray => {
        innerArray.forEach(obj => {
            const label = obj.label
            if (!groupedData[label]) {
                groupedData[label] = {
                    id: obj.sparte,
                    label: label,
                    merkmale: [],
                }
            }
            groupedData[label].merkmale.push(...obj.merkmale)
        })
    })

    return Object.values(groupedData)
}

const extractSpartenMerkmalstructure = sparten => {
    const spartenWithMerkmale = sparten?.map(sparte =>
        sparte.sparten?.flatMap(katalog => ({
            sparte: sparte.id,
            label: sparte.label,
            merkmale: katalog?.connections?.map(
                merkmalConnection => merkmalConnection.origin,
            ) ?? [],
        })),
    )

    return groupMerkmaleByLabel(spartenWithMerkmale)
}

const extractAnlassSparten = (anlaesse, spartenmerkmale) => {
    return anlaesse?.flatMap(anlass =>
        anlass.kategorie.flatMap(sammlung => ({
            anlass: sammlung.id,
            label: sammlung.label,
            sparten: sammlung?.connections?.map(
                spartenConnection => spartenmerkmale.find((sparte) => sparte.id === spartenConnection.id)) ?? [],
        }))
    )
}

export const ProduktfinderActions = ({
    getDataFromPointer,
    updateData,
}) => {
    return {
        INIT_PRODUKTFINDER: () => {
            const produktgeberList =
                rawData["ak-deprecated"].produkte
            const sparten = rawData["ak-deprecated"].spartenbaum
            const produktInfo = produktgeberList.flatMap(produktgeber => ({
                label: produktgeber.label,
                produkte: produktgeber.children.map(produkt => ({
                    label: produkt.label,
                    merkmale: produkt.merkmale,
                    sparte: produkt?.connections?.map(
                        connection => connection.id,
                    ),
                })),
            }))
            const spartenMerkmaleWithBedingungsmerkmale =
                extractSpartenMerkmalstructure(sparten)
            const bedingungsMerkmaleGroupedBySparte =
                spartenMerkmaleWithBedingungsmerkmale.map(sparte =>
                    sparte.merkmale
                        .filter(
                            merkmal =>
                                merkmal.conditionalattribute?.attributes
                                    ?.length,
                        )
                        .flatMap(
                            merkmal => merkmal.conditionalattribute?.attributes,
                        ),
                )
            const spartenMerkmale = spartenMerkmaleWithBedingungsmerkmale.map(
                (sparte, index) => ({
                    ...sparte,
                    merkmale: sparte.merkmale.filter(
                        merkmal =>
                            !bedingungsMerkmaleGroupedBySparte[index].some(
                                bedingungsmerkmal =>
                                    bedingungsmerkmal.id === merkmal.id,
                            ),
                    ),
                }),
            )
            const bedingteMerkmaleList = spartenMerkmaleWithBedingungsmerkmale
                .map((sparte, index) => ({
                    ...sparte,
                    merkmale: sparte.merkmale.filter(merkmal =>
                        bedingungsMerkmaleGroupedBySparte[index].some(
                            bedingungsmerkmal =>
                                bedingungsmerkmal.id === merkmal.id,
                        ),
                    ),
                }))
                .flatMap(sparte => sparte.merkmale)
            const anlaesse = rawData["ak-deprecated"].anlassbaum
            const anlassSparten = extractAnlassSparten(
                anlaesse,
                spartenMerkmale,
            )
            const allProdukte = produktInfo.flatMap(produktCategory => produktCategory.produkte)
            updateData(spartenMerkmale, "/sparteList")
            updateData(produktInfo, "/produktInfo")
            updateData(anlassSparten, "/anlassList")
            updateData(allProdukte, "/allProdukte")
            updateData(bedingteMerkmaleList, "/bedingteMerkmaleList")
        },
        "checkSparten": () => {
            const sparten = getDataFromPointer("/sparteList")
            const anlaesse = getDataFromPointer("/anlassList")
            const chosenAnlaesse = anlaesse.filter(anlass => anlass.chosen)
            const spartenIdsInChosenAnlaessen = new Set(
                chosenAnlaesse
                    ?.flatMap(anlass => anlass.sparten)
                    .map(sparte => sparte.id),
            )
            const updatedSparten = sparten.map(sparte => ({
                ...sparte,
                kunde: spartenIdsInChosenAnlaessen.has(sparte.id)
            }))
            updateData(updatedSparten, "/sparteList")
        },
        "produktSelected": () => {
            const searchParameter = getDataFromPointer("/suche")
            const produktListe = getDataFromPointer("/allProdukte")
            const spartenMerkmale = getDataFromPointer("/sparteList")
            const currentMerkmale = (produkt) => spartenMerkmale?.find(sparte => sparte.id === produkt?.sparte[0])?.merkmale ?? []
            const labels = produktListe?.map(produkt => produkt.label)

            const barData = [{
                labels: labels,
                data: produktListe?.filter(produkt => produkt.chosen).map(produkt => ({
                    value: calculateMatchPercentage(produkt, searchParameter, currentMerkmale(produkt)),
                    label: produkt?.label,
                    backgroundColor: "#1565FF",
                    stack: produkt?.label,
                }))
            }]

            updateData(barData, "/auswertungBarData")
        },
    }
}
